import { render, staticRenderFns } from "./TrainValidate.vue?vue&type=template&id=371e2242&scoped=true&"
import script from "./TrainValidate.vue?vue&type=script&lang=js&"
export * from "./TrainValidate.vue?vue&type=script&lang=js&"
import style0 from "./TrainValidate.vue?vue&type=style&index=0&id=371e2242&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371e2242",
  null
  
)

export default component.exports